import type {Media} from "crqlar-react-common/dist/models/common/media.model";
import {useOrganization} from "crqlar-react-common/dist/state/auth.reducer";
import {getScaledUrl, MediaSize} from "crqlar-react-common/dist/utils/media.util";

/*
    Copied from the survey QR (`surveys/share/surveyQrBranding.util.ts`). The logo covers the center
    of the code, so its geometry derives from the code's own size: a centered square of
    QR_LOGO_MAX_RATIO hides 4% of the modules, well inside what error correction H recovers.
*/

/** Edge length of the logo as a fraction of the code's edge length. */
export const QR_LOGO_MAX_RATIO = 0.2

/** Breathing room between logo and the edge of its white pad, as a fraction of the logo box. */
export const QR_LOGO_PAD_RATIO = 0.08

/** Corner radius of the white pad, as a fraction of the logo box. */
export const QR_LOGO_RADIUS_RATIO = 0.12

/** A length derived from the code's size: plain pixels, or calc() for a CSS size like 'min(70vw, 70vh)'. */
export const qrLogoLength = (size: number | string, ratio: number) =>
    typeof size === 'number' ? `${size * ratio}px` : `calc(${size} * ${ratio})`

const withUri = (...candidates: (Media | undefined)[]) => candidates.find(media => !!media?.mediaURI)

/**
 * The organization's mark for the signing QR code, or undefined without one. Same order as
 * the hotel logo on the guest page (`media`, else `logo`), so the code and the page it opens carry
 * the same mark.
 */
export const useSigningQrLogoUrl = (): string | undefined => {
    const organization = useOrganization()

    const media = withUri(organization?.media, organization?.logo)

    return getScaledUrl(media, MediaSize.MEDIUM_300, MediaSize.MEDIUM_300) || undefined
}
